import { render } from "./CreateJournal.vue?vue&type=template&id=52283884&scoped=true"
import script from "./CreateJournal.vue?vue&type=script&lang=js"
export * from "./CreateJournal.vue?vue&type=script&lang=js"

import "./CreateJournal.vue?vue&type=style&index=0&id=52283884&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52283884"]])

export default __exports__